import { useContext } from 'react';
import { FormikContext } from 'formik';
import LibSelectField, { SelectFieldOption } from '../../libs/frontend-lib/components/Fields/SelectField';
import { FormTrackingContext } from '../Form';
import { useTranslation } from '../../hooks/i18n';
import { logFieldChange } from '../../utils/tracking';
import { CommonProps } from './types';

type SelectFieldProps = CommonProps & {
  value?: string;
  options: SelectFieldOption[];
  renderOption?: (option: SelectFieldOption) => React.ReactNode;
  renderValue?: (value: any) => React.ReactNode;
  startAdornment?: React.ReactNode;
  hideErrorText?: boolean;
};

// Bridge to the lib component: connects it to Formik, form tracking and translations,
// so the call sites do not change.
export default function SelectField({
  name,
  value,
  onChange,
  error,
  eventLogger = logFieldChange,
  hideLabel,
  ...rest
}: SelectFieldProps) {
  const { t } = useTranslation();
  const formik = useContext(FormikContext);
  const { trackingEvent } = useContext(FormTrackingContext);

  return (
    <LibSelectField
      {...rest}
      optionalLabel={t('optional')}
      value={value || formik?.values[name]}
      error={error || (formik?.touched[name] && formik?.errors[name])}
      onChange={(newValue) => {
        formik && formik.setFieldValue(name, newValue);
        onChange && onChange(newValue);
        trackingEvent && eventLogger(trackingEvent, name, newValue);
      }}
      onBlur={() => formik && formik.setFieldTouched(name, true)}
      onClear={() => {
        formik && formik.setFieldValue(name, '');
        onChange && onChange('');
      }}
    />
  );
}
